
import { defineComponent, computed, ref, watch } from 'vue'
import QTable from 'quasar/src/components/table/QTable.js';
import MasterTable from '@/components/master/MasterTable.vue'
import {
  required as requiredRule,
  minCharactersRule,
  requiredNotNegative,
} from '@/common/formValidationRules'
import { useTrackCount } from '@/composable/useTrackCount'
import { TrackCount } from '@/api/track-count/getTrackCount'

export default defineComponent({
  name: 'TrackCount',

  components: {
    MasterTable,
  },

  setup() {
    const { loading, data, add, remove, update } = useTrackCount(true)

    const model = ref<TrackCount>({
      from: '',
      to: '',
      track_count: 1,
    })

    function resetFormModel() {
      model.value = { from: '', to: '', track_count: 1 }
    }

    const columns: QTable['columns'] = [
      {
        name: 'from',
        label: 'Från',
        align: 'left',
        field: 'from',
        sortable: true,
      },
      {
        name: 'to',
        label: 'Till',
        align: 'left',
        field: 'to',
        sortable: true,
      },
      {
        name: 'track_count',
        label: 'Spårantal',
        align: 'left',
        field: 'track_count',
        sortable: true,
      },
    ]

    const exportData = computed(() => {
      interface ExportRow {
        [key: string]: unknown
      }

      return data.value.map((TrackCount) => {
        return columns.reduce<ExportRow>((acc, column) => {
          const value = TrackCount[column.field as keyof TrackCount]
          acc[column.label] =
            column.format && value ? column.format(value, null) : value
          return acc
        }, {})
      })
    })

    const showCSVModal = ref(false)
    const csvModel = ref('')

    const parseCsv = (csv: string) => {
      return csv
        .trim() // Remove any leading/trailing empty lines
        .split('\n') // Split into individual lines
        .map((line) => {
          const [from, to, trackCount] = line
            .split(',')
            .map((item) => item.trim())

          return {
            from,
            to,
            track_count: parseInt(trackCount, 10),
          }
        })
    }
    const loadingCSVImport = ref(false)
    const onCSVImport = async () => {
      loadingCSVImport.value = true
      const payload = parseCsv(csvModel.value)
      if (payload.length) {
        await add(payload)
      }
      showCSVModal.value = false
      loadingCSVImport.value = false
    }

    watch(showCSVModal, () => {
      csvModel.value = ''
    })

    return {
      minCharactersRule: minCharactersRule(8),
      columns,
      model,
      requiredRule,
      resetFormModel,
      requiredNotNegative,
      data,
      exportData,
      loading,
      add,
      update,
      remove,
      showCSVModal,
      onCSVImport,
      csvModel,
      loadingCSVImport,
    }
  },
})
